import { formatDate } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  private readonly _translocoService = inject(TranslocoService);

  transform(value: string, pattern = 'mediumDate'): string {
    return formatDate(value, pattern, this._translocoService.getActiveLang());
  }
}
